import React from 'react';

const LearnMoreCard = ({content}) => {
    return(
        <div className="botActivityClass activityClass" style={{marginLeft:"3rem"}}>
            <div className="botTextBox conversationTextBox">
                <div className="conv-text">
                    <div className="learnMore">
                        <span>
                            <div style={{display:"flex"}}>
                                <div style={{display:"block",fontSize:"15px"}}>
                                    <a href={content.learnMoreLink} target="_blank">
                                        {content.name}
                                    </a>
                                </div>
                            </div>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LearnMoreCard;
